import { createReducer, on } from "@ngrx/store";
import { cargaFormasEnvio, resetFormasEnvio } from "./actions";
import { iFormasEnvio } from "../../entrada/entrada.interface";

export const initialState: iFormasEnvio[] = [];

export const formasEnvioReducer = createReducer(
  initialState,
  on(cargaFormasEnvio, (state, payload) => {
    return [...payload.oFormasEnvio]; 
  }),
  on(resetFormasEnvio, (state, payload) => {
    return initialState;
  })
);
